module.exports = __webpack_public_path__ + "img/user-1.049458b1.png";